module.exports = __webpack_public_path__ + "u15.no2.d6ab3ed4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/u15.no2.jpg
// module id = YB8n
// module chunks = 0